import { appPort, jumpModuleApp } from '@/widget';
import { hostPath } from '@utils/basePath';
export default {
    props: {
        list: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        toDetail(id) {
            this.$emit('toRecommend', { recommendType: 'commodity' });
            if (appPort()) {
                jumpModuleApp({
                    typeId: 'mall_detail',
                    dataId: id
                });
            }
            else {
                location.assign(`${hostPath}/mall/detail?productId=${id}`);
            }
        }
    }
};
